import React from 'react'
import styled from 'styled-components'
import File from './File'

const FilesContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
`

export default ({ files, ...rest }) => (
  <FilesContainer>
    {
      (files !== undefined) && 
        files.map(({ name, filename, rid, link}) => {
          if (name !== undefined) {
            return <File key={`${name}`} filename={name} {...rest}/>
          } else {
            return <File key={`${filename}${rid}`} filename={filename} link={link} {...rest}/>
          }
        })
    }
  </FilesContainer>
)
